import React from 'react';

import { Alert, Center, Container, Group, LoadingOverlay, Title } from '@mantine/core';
import { IconExclamationCircle } from '@tabler/icons-react';
import PageHeader from 'components/PageHeader';
import { useAuth } from 'context/auth-context';
import useGoogleCalendarIntegrations from 'hooks/googleCalendarIntegration/useGoogleCalendarIntegrations';

import CreateGoogleCalendarIntegration from './components/CreateGoogleCalendarIntegration';
import ExistingGoogleCalendarIntegration from './components/ExistingGoogleCalendarIntegration';

export const GOOGLE_API_SCOPES = [
  'https://www.googleapis.com/auth/calendar.readonly',
  'https://www.googleapis.com/auth/calendar.events',
  'https://www.googleapis.com/auth/userinfo.email',
];

const Integration = (): JSX.Element => {
  const { session } = useAuth();

  const { data, isLoading, isSuccess, isError } = useGoogleCalendarIntegrations({
    staff: session?.staff?.staffId,
    enabled: !!session?.staff?.staffId,
  });

  const googleCalendarIntegration = data?.pages[0].data.results[0];

  return (
    <>
      <PageHeader>
        <Group position='apart' align='center' noWrap>
          <Title order={1} size='h1'>
            Integration
          </Title>
        </Group>
      </PageHeader>

      <div style={{ overflowY: 'scroll' }}>
        <Container maw='650px'>
          <LoadingOverlay visible={isLoading} />
          {isError && (
            <Center p='lg'>
              <Alert icon={<IconExclamationCircle size='1rem' />} title='Error' color='red'>
                Something went wrong while fetching data!
              </Alert>
            </Center>
          )}
          {isSuccess && !googleCalendarIntegration && <CreateGoogleCalendarIntegration />}
          {isSuccess && googleCalendarIntegration && (
            <ExistingGoogleCalendarIntegration googleCalendarIntegration={googleCalendarIntegration} />
          )}
        </Container>
      </div>
    </>
  );
};

export default Integration;
